<template>
  <div class="ds-control mobile dsf_teas_course_info">
    <div class="search">
      <van-search v-model="keywords" shape="round" @input="search" placeholder="搜索" />
    </div>
    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="list.length > 0">
        <van-list v-model="loading" :finished="finished" :error.sync="error" finished-text="没有更多了" @load="getList">
          <div class="list">
            <DsfMobileTeasCardDesc :isShowBg="false" v-for="(item, index) in list" :titleEllipsis="2" @click.native="itemClick(item)" :key="index" :title="item.courseName">
              <DsfMobileTeasCardDescItem icon="icon-shijian" :value="item.courseTimeSdate" :col="12"></DsfMobileTeasCardDescItem>
              <DsfMobileTeasCardDescItem icon="icon-icon-teacher" :value="item.teacher" :col="12"></DsfMobileTeasCardDescItem>
              <DsfMobileTeasCardDescItem icon="icon-location-hollow" :value="item.place || '暂无'" :col="12"></DsfMobileTeasCardDescItem>
              <DsfMobileTeasCardDescItem icon="icon-icon-num" :value="item.should + '人'" :col="12"></DsfMobileTeasCardDescItem>
              <div class="list_num" slot="ft">
                <div class="num_value">
                  <div v-if="systemArr.includes('1')">出勤: {{item.onTime}}</div>
                  <div>请假: {{item.leave}}</div>
                  <div>未签: {{item.notSign}}</div>
                  <div v-if="systemArr.includes('3')">晚到: {{item.seriousLate}}</div>
                  <div v-if="systemArr.includes('4')">早退: {{item.early}}</div>
                  <div v-if="systemArr.includes('2')">迟到: {{item.late}}</div>
                </div>
                <div class="attendance">
                  <span>{{ item.attendRate }}</span>
                  <div>考勤率</div>
                </div>
              </div>
            </DsfMobileTeasCardDesc>
          </div>
        </van-list>
      </van-pull-refresh>
      <van-empty v-else description="暂无数据" />
    </div>
  </div>
</template>

<script>
const testData = [
  {
    id: "52c6a2c519d14ccbbdff84d91ceac89d",
    courseName: "生态文明之路—生态文明建设理论与实践的解读与思考",
    scheduleNoonId: "e54519b550b74554ae828a74cacbde72",
    courseTimeSdate: "2021-03-16 08:40",
    teacher: null,
    place: null,
    should: 2,
    onTime: 0,
    attend: 0,
    exception: 2,
    leave: 0,
    attendRate: "0%",
    state: 1,
  },
  {
    id: "22c870c4caee4c5ab64d279dd555da8a",
    courseName: "经典文学辅导课程",
    scheduleNoonId: "c0a812d7b98e4004a49b3771e37dbb3c",
    courseTimeSdate: "2021-03-16 14:30",
    teacher: null,
    place: null,
    should: 2,
    onTime: 0,
    attend: 0,
    exception: 2,
    leave: 0,
    attendRate: "0%",
    state: 1,
  },
];
export default dsf.component({
  name: "DsfMobileTeasCourseInfo",
  mixins: [$mixins.control],
  ctrlCaption: "班次课程信息-班主任",
  design: {
    isMask: false,
  },
  props: {
    sourcesUrl: {
      type: String,
      default: "/teas/mobile/attendance/queryCourseAttendStatisticByClassId",
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      pageNum: 0,
      classId: '',
      keywords: "",
      list: [],
      systemArr: []
    };
  },
  created() {
    if (this.isDesign) {
      this.list = testData;
    } else {
      this.classId = this.$route.query.classId
      this.getList();
      this.getSystem();
    }
  },
  activated: function () {
    this.onRefresh();
  },
  methods: {
    itemClick(item) {
      this.$router.push('/mobile/teas/attendance/mobile/kqxq?classId=' + this.classId + '&relId=' + item.id + '&elective=' + this.queryString.elective+'&isGroup='+item.isGroupValue)
    },
    search: _.debounce(function () {
      this.onRefresh()
    }, 300),
    // 获取列表数据
    getList(isRefresh = false) {
      const loading = dsf.layer.loading();
      this.pageNum++;
      this.$http
        .get(this.$replace(this.sourcesUrl, this), {
          pageNum: this.pageNum,
          classId: this.classId,
          search: this.keywords
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            if (isRefresh) {
              this.list = res.data.list
            } else {
              this.list.push(...res.data.list);
            }
            this.finished = res.data.lastPage;
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
            this.finished = true
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
          this.finished = true
        })
        .always(() => {
          this.loading = false
          this.refreshing = false
          dsf.layer.closeLoading(loading);
        });
    },
    getSystem() {
      this.$http.get('teas/attendance/getSystemAttendRules', {}).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          this.systemArr = res.data.split('^')
        } else {
          dsf.layer.message(res.message, false);
        }
      }).error((err) => {
        dsf.layer.message(err.message || "出错了，请重试", false);
      })
        .always(() => {
        });
    },
    // 刷新
    onRefresh() {
      this.pageNum = 0
      this.getList(true)
      this.getSystem();
    },
  },
});
</script>